import api from '.';

// Preserva os parâmetros existentes do listarObj e transporta explicitamente o contexto do menu.
// Não altera o CRUD compartilhado pelas demais telas.
export const listarMovimentos = ({
    start, size, filters, filtersMode, globalFilter, sorting, tipoConsulta,
    operacaoId, empresaId, limitarRegistros = false, operacaoSigla, homologationId,
    menuSubId, natureza, origem, classificacaoConferencia = 'menu',
}) => api.get('/movimento/listar/', {
    params: {
        start, size, filters, filtersMode, globalFilter, sorting, tipoConsulta,
        operacaoId, empresaId, limitarRegistros, operacaoSigla, homologationId,
        menuSubId, natureza, origem, classificacaoConferencia,
    },
});
